<template>
	<div class="row">
        <template v-if="datos_guardados[0].plazos">
            <div class="col-12 col-lg-8">
                <table class="table tabla-resumen table-bordered mb-4 mb-lg-5">
                    <tr class="lightgray-content">
                        <th></th>
                        <th>{{ $t('general.abono') }}</th>
                        <th class="price">{{ $t('general.precio') }}</th>
                        <th>Plazos</th>
                    </tr>

                    <template v-for="(entrada, index) in datos_guardados">
                        <tr :key="index">
                            <td class="h1 text-center regular">{{++index}}</td>
                            <td>
                                <strong class="text-bold h5 d-block mb-1">{{entrada.descuento.tipo }}</strong>
                                <template v-if="entrada.asiento">
                                    <strong class="text-bold h7 d-block mb-1" v-if="entrada.asiento.zona_nombre">{{ entrada.asiento.zona_nombre }}</strong>
                                    <strong class="text-bold h7 d-block mb-1" v-if="entrada.asiento.zona_nombre"> {{ $t('general.fila') }}: {{ entrada.asiento.fila }} - {{ $t('general.butaca') }}: {{ entrada.asiento.asiento }}</strong>
                                </template>
                                <template v-else>
                                    <strong class="text-bold h7 d-block mb-1">{{ entrada.tipo_abono.descripcion }}</strong>
                                </template>
                            </td>
                            <td>
                                <div class="h3 m-0"><del>{{ entrada.descuento.precio_total | formatear_precio }}</del></div>
                            </td>
                            <td>
                                <ul>
                                    <template v-for="(plazo, key) in entrada.plazos_pendientes">
                                        <li :key="key">
                                            <template v-if="plazo.gastos_internos == 0">
                                                Plazo: {{ ++key }} <span v-if="plazo.informacion">({{ plazo.informacion }})</span> - {{ plazo.importe + plazo.gastos  | formatear_precio }}
                                            </template>
                                            <template v-else>
                                                Plazo: {{ ++key }} <span v-if="plazo.informacion">({{ plazo.informacion }})</span> - {{ plazo.importe  | formatear_precio }}
                                            </template>                                            
                                        </li>
                                    </template>    
                                    
                                </ul>               
                            </td>
                        </tr>
                    </template>
                    <tr>
                        <td colspan="2"></td>
                        <td><del class="total-price h2 m-0">{{ total | formatear_precio }}<span v-if="!datos_guardados[0].descuento.price_management_interno">*</span></del></td>
                        <td><span class="total-price h2 m-0">{{ total_plazos | formatear_precio }}<span v-if="!datos_guardados[0].descuento.price_management_interno">*</span></span></td>
                    </tr>
                </table>
            </div>
            <div class="col-12 col-lg-8 mb-4" v-if="teatro.permitir_plazos_abonados == 1">
                <button id="pago-plazos" class="button large-button effect-button" @click.prevent="solicitarPagoCompleto()"><span>O pagar importe completo</span></button>
            </div>
        </template>
        <template v-else>
            <div class="col-12 col-lg-8">
                <table class="table tabla-resumen table-bordered mb-4 mb-lg-5">
                    <tr class="lightgray-content">
                        <th></th>
                        <th>{{ $t('general.abono') }}</th>
                        <th class="price">{{ $t('general.precio') }}</th>
                    </tr>

                    <template v-for="(entrada, index) in datos_guardados">
                    <tr :key="index">
                        <td class="h1 text-center regular">{{++index}}</td>
                        <td>
                            <strong class="text-bold h5 d-block mb-1">{{entrada.descuento.tipo }}</strong>
                            <template v-if="entrada.asiento">
                                <strong class="text-bold h7 d-block mb-1" v-if="entrada.asiento.zona_nombre">{{ entrada.asiento.zona_nombre }}</strong>
                                <strong class="text-bold h7 d-block mb-1" v-if="entrada.asiento.zona_nombre"> {{ $t('general.fila') }}: {{ entrada.asiento.fila }} - {{ $t('general.butaca') }}: {{ entrada.asiento.asiento }}</strong>
                            </template>
                            <template v-else>
                                <strong class="text-bold h7 d-block mb-1">{{ entrada.tipo_abono.descripcion }}</strong>
                            </template>                           
                        </td>
                        <td>
                            <div class="h3 m-0">{{ entrada.descuento.precio_total | formatear_precio }}</div>
                        </td>
                    </tr>
                    </template>
                    <tr>
                        <td colspan="2"></td>
                        <td><span class="total-price h2 m-0">{{ total | formatear_precio }}<small v-if="!datos_guardados[0].descuento.price_management_interno">*</small></span></td>
                    </tr>
                </table>
            </div>

            <div class="col-12 col-lg-8 mb-4" v-if="teatro.permitir_plazos_abonados == 1 && ! solicitar_iban">
                <button id="pago-plazos" class="button large-button effect-button" @click.prevent="solicitar_iban = true"><span>O pagar a plazos</span></button>
            </div>
            <template v-if="solicitar_iban">
                <div class="col-12 col-lg-8 mb-4">
                    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                        <p>Si quieres pagar a plazos, debes introducir tu número de cuenta completo incluido IBAN.</p>
                        <FormInput label="Iban" name="Iban" rules="required" v-model="iban" />
                        <FormInput label="Titular de la cuenta" name="Titular de la cuenta" rules="required" v-model="titular_cuenta" />
                        <p>Los siguientes cobros de tu abono se realizarán automáticamente en tu cuenta bancaria.</p>
                        <button type="submit" class="button large-button effect-button" name="Continuar">Validar</button>
                    </ValidationObserver>
                </div>
            </template>
        </template>
        <div class="col-12 col-lg-8">
            <div class="form-group">
                <div class="checkbox-container mb-2">
                    <input type="checkbox" name="privacidad" id="privacidad" :class="!privacidad && error ? 'is-invalid' : ''" v-model="privacidad">
                    <label for="privacidad">
                        {{ $t('formularios.he_leido') }}
                        <router-link
                            :to="{ name: 'legal' }"
                            target="_blank"
                        >
                            <span>{{ $t('formularios.terminos_condiciones') }}</span>
                        </router-link> 
                        y la 
                        <router-link
                            :to="{ name: 'privacidad' }"
                            target="_blank"
                        >
                            <span>{{ $t('formularios.politica_privacidad') }}</span>
                        </router-link>
                    </label>
                </div>
                <span class="error" v-if="!privacidad && error">{{ $t('formularios.error_terminos') }}</span>
            </div>
            <div class="form-group">
                <div class="checkbox-container mb-2">
                    <input type="checkbox" name="condiciones" id="condiciones" :class="!condiciones && error ? 'is-invalid' : ''" v-model="condiciones">
                    <label for="condiciones">{{ $t('formularios.acepto_condiciones') }}</label>
                </div>
                <span class="error" v-if="!condiciones && error">{{ $t('formularios.error_condiciones') }}</span>
            </div>
            <div class="form-group">
                <div class="checkbox-container mb-2">
                    <input type="checkbox" name="comunicaciones" id="comunicaciones" :class="!comunicaciones && error ? 'is-invalid' : ''" v-model="comunicaciones">
                    <label for="comunicaciones">{{ $t('formularios.acepto_comunicaciones') }}</label>
                </div>
                <span class="error" v-if="!comunicaciones && error">{{ $t('formularios.error_comunicaciones') }}</span>
            </div>
            <p class="mb-2 mb-md-4">
                <small v-if="!datos_guardados[0].descuento.price_management_interno">
                    * {{ $t('general.el_precio', { precio: $options.filters.formatear_precio(total_sin_gd), gastos: $options.filters.formatear_precio(total_gd), iva: 21, moneda: '€' }) }}
                </small>
            </p>
            <button id="terminar-compra" class="button large-button effect-button" @click.prevent="terminar"><span>{{ $t('nuevo_abono.continuar') }}</span></button>
            <template v-if="formulario != null" >
                <div id="formulario-compra" v-html="formulario" v-show="false">

                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['entradas', 'formulario', 'datos_guardados'],
        data() {
            return {
                condiciones: null,
                comunicaciones: null,
                error: false,
                privacidad: false,
                solicitar_iban: false,
                iban: '',
                titular_cuenta: ''
            }
        },
        computed: {
            total_plazos() {
                var total = 0;
                for(var i in this.datos_guardados) {
                    if (this.datos_guardados[i].plazos_pendientes) {
                        if(this.datos_guardados[i].plazos_pendientes[0].gastos_internos == 0) {
                            total = total + parseFloat(this.datos_guardados[i].plazos_pendientes[0].importe + this.datos_guardados[i].plazos_pendientes[0].gastos);
                        } else {
                            total = total + parseFloat(this.datos_guardados[i].plazos_pendientes[0].importe);
                        }                        
                    }                    
                }

                return total;
            },
            total() {
                var total = 0;
                for(var i in this.datos_guardados) {
                    total = total + parseFloat(this.datos_guardados[i].descuento.precio_total);
                }

                return total;
            },
			total_sin_gd() {
				var total = 0;
                for(var i in this.datos_guardados) {
                    total = total + parseFloat(this.datos_guardados[i].descuento.precio);
                }

                return total;
			},
			total_gd() {
				var total = 0;
                for(var i in this.datos_guardados) {
                    total = total + parseFloat(this.datos_guardados[i].descuento.price_management);
                }

                return total;
			},
            teatro() {
                return this.$store.getters.getTeatro;
            },
            footer() {
                return this.$store.getters.getFooter
            }
        },
        methods: {
            terminar() {
                if(this.condiciones &&  this.privacidad) {
                    setTimeout(() => {
                        document.getElementById('btn-pagar').click();
                    }, 1000);
                } else {
                    this.error = true;
                }
                
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.solicitarPlazos();
                }
            },
            solicitarPlazos() {
                this.solicitar_iban = false;
                this.datos_guardados.forEach(abonado => {
                    abonado.plazos = true;
                    abonado.iban = this.iban;
                    abonado.titular_cuenta = this.titular_cuenta;
                });

                this.$emit('solicitarPlazos', this.datos_guardados);
            },
            solicitarPagoCompleto() {
                this.datos_guardados.forEach(abonado => {
                    abonado.plazos = false;
                    abonado.iban = null;
                    abonado.titular_cuenta = null;
                });
                this.$emit('solicitarPlazos', this.datos_guardados);
            }
        },
    }
</script>
